module.exports = __webpack_public_path__ + "static/whatWeDoBanner-c4eba8931ed00135f7635bd24132124a.png";